import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "@/views/Home.vue";
import CampaignList from "@/views/CampaignList.vue";
import ForceList from "@/views/ForceList.vue";
import ForceDetail from "@/views/ForceDetail.vue";
import RouteNames from "./RouteNames";

Vue.use(VueRouter);

const homePath = "/home";

const routes: Array<RouteConfig> = [
  {
    path: homePath,
    name: RouteNames.HOME,
    component: Home,
  },
  {
    path: "/campaigns",
    name: RouteNames.CAMPAIGN_LIST,
    component: CampaignList,
  },
  {
    path: "/forces",
    name: RouteNames.FORCE_LIST,
    component: ForceList,
  },
  {
    path: "/forces/:id",
    name: RouteNames.FORCE_DETAIL,
    props: true,
    component: ForceDetail,
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/*",
    redirect: homePath,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
